module.exports = __webpack_public_path__ + "img/ko-kr.d2d31639.png";